import { columns } from "./columns";
import { Heading } from "../../ui/heading";
import { Separator } from "../../ui/separator";
import { ProjectsType } from "@/src/data/types";
import { DataTable } from "../../ui/data-table";
import { Button } from "../../ui/button";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ProjectsProps {
  data: ProjectsType[];
}

export const ProjectsData: React.FC<ProjectsProps> = ({ data }) => {
  const router = useNavigate();

  return (
    <>
      <div className="flex items-start justify-between">
        <Heading
          title={`Travaux (${data.length})`}
          description="Liste des travaux "
        />

        <Button
          className="text-xs md:text-sm"
          onClick={() => router(`/admin-dashboard/travaux/ajouter`)}
        >
          <Plus className="w-4 h-4 mr-2" /> Ajouter
        </Button>
      </div>
      <Separator />
      <DataTable searchKey="title" columns={columns} data={data} />
    </>
  );
};
